import { Box, Typography } from '@mui/material';
import { FC } from 'react';

import { PrimaryButton } from '@/components';
import { AppModal } from '@/components/Elements/Modal';

interface IProps {
    open: boolean;
    title: string;
    onClose: () => void;
    onAgree: () => void;
}

export const ModalConfirm: FC<IProps> = ({ open, onClose, title, onAgree }) => {
    return (
        <AppModal open={open} onClose={onClose} style={{ px: 4, py: 2 }}>
            <Box sx={{ px: 3, py: 2 }}>
                <Typography variant="caption">{title}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 3 }}>
                <PrimaryButton title="Agree" onClick={onAgree} />
                <PrimaryButton title="Cancel" onClick={onClose} white />
            </Box>
        </AppModal>
    );
};
